import { environment } from '../../../../../environments/environment'
import {
	Component,
	OnInit,
	ViewChild,
	Input,
	Output,
	EventEmitter
} from '@angular/core'
import { NotificationService } from 'src/app/services/notification.service'

import { ImageGaleryOperationService, OperationServiceScheduleDetails } from 'src/app/models/OperationService'
import { OperationServiceService } from 'src/app/services/operation.service.service'

import { NgForm } from '@angular/forms'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { CompanyServiceProvider } from 'src/app/models/CompanyServiceProvider'
import { CompanyServiceProviderService } from 'src/app/services/company-service-provider'

@Component({
	selector: 'app-operation-schedule',
	templateUrl: './operation-schedule.component.html'
})
export class OperationScheduleComponent implements OnInit {

	constructor(
		public notificationService: NotificationService,
		private operationServiceService: OperationServiceService,
		private companyServiceProviderService: CompanyServiceProviderService
	) {}

	@Output() public getOperationsServices: EventEmitter<void> = new EventEmitter()
	@Output() public runToSteps = new EventEmitter<OperationServiceScheduleDetails>()
	@Output() public close: EventEmitter<void> = new EventEmitter()
	@Input() public idMongo: string

	@ViewChild('form') public form: NgForm

	public companiesServiceProvider: Array<CompanyServiceProvider> = []
	public operationService: OperationServiceScheduleDetails
	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()
	public galeryOperationService: Array<ImageGaleryOperationService> = []
	public galeryOperationServiceRefused: Array<ImageGaleryOperationService> = []
	public photoSelected: ImageGaleryOperationService
	public carouselPages: number = 0
	public carouselPagesRefuse: number = 0
	public carouselPageNow: number = 1
	public carouselPageNowRefused: number = 1

	public ViewValidation: ViewValidation = new ViewValidation()
	public myMap: google.maps.Map

	public alertOpen: boolean = false
	public openDelete: boolean = false
	public lastStepCancellation: boolean = false
	public isAdmin: boolean = false
	public isUserAdmin: boolean = false
	public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public refusedArrowLeftEnable: boolean = false
	public refusedArrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public showSelectCompanyProvider: boolean = false
	public enableSelectCompanyProvider: boolean = false
	public justifyCancel: string = ''

	public async ngOnInit(): Promise<void> {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
		this.isUserAdmin = Boolean(this.sessionUser.roles.includes('CUSTOMER'))

		this.enableSelectCompanyProvider =
			this.sessionUser.assignments.includes('OPERATION_SERVICE_SCHEDULE_UPDATE') || this.isAdmin

		setTimeout(() => {
			window.scrollTo(0 , 0)
		}, 250)

		await this.getOperationServiceSelected()
		await this.setGaleryOperationService()

		if (this.operationService.operationRefused) {
			await this.setGaleryOperationServiceRefused();
		}
	}

	public async getOperationServiceSelected() {
		this.operationService =
			await this.operationServiceService.getOperationServiceSelected(this.idMongo).toPromise()
	}

	public openSteps(): void {
		this.runToSteps.emit(this.operationService)
		this.close.emit()
	}

	public closeModal(): void {
		this.close.emit()
	}

	public openDeleteModal(): void {
		this.openDelete = true
	}

	public closeDeleteModal(): void {
		this.openDelete = false
	}

	public openAlertModal() {
		this.alertOpen = !this.alertOpen
		this.lastStepCancellation = false
		this.justifyCancel = ''

		removeToolTip()
	}

	public runLastStepCancellation() {
		this.lastStepCancellation = true
	}

	public async cancelOperation(): Promise<void> {
		try {
			const response: any = await this.operationServiceService
				.cancelOperation(
					this.operationService.idMongo,
					this.justifyCancel
				)
				.toPromise()
			this.getOperationsServices.emit()
			this.closeModal()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async deleteOperation(): Promise<void> {
		try {
			const response = await this.operationServiceService.deleteOperation(this.operationService.idMongo).toPromise()
			this.getOperationsServices.emit()
			this.closeModal()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}

	}

	public async closeOperation(): Promise<void> {
		try {
			const response = 
				await this.operationServiceService.closeOperation(
					this.operationService.idMongo
				).toPromise();

			this.getOperationsServices.emit()
			this.closeModal()
			this.notificationService.notify(response, 200)
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public openClosePhotoFromCarousel(photo?: ImageGaleryOperationService) {
		if (photo) {
			this.photoSelected = photo
			this.photoFromCarouselEnable = true
		} else {
			this.photoSelected = null
			this.photoFromCarouselEnable = false
			removeToolTip()
		}
	}

	public moveCarousel(direction: 'left' | 'right') {
		const carousel = document.getElementById('carousel-content') as HTMLDivElement
		const carouselWidth: number = 748

		if (direction == 'left') {
			if (this.carouselPageNow > 1) {
				this.carouselPageNow--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNow < this.carouselPages) {
				this.carouselPageNow++
			}
		}

		if (this.carouselPageNow > 1) {
			this.arrowLeftEnable = true
		} else {
			this.arrowLeftEnable = false
		}

		if (this.carouselPageNow == this.carouselPages) {
			this.arrowRightEnable = false
		} else {
			this.arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public moveCarouselRefuse(direction: 'left' | 'right') {
		const carousel = document.getElementById('carousel-content-refused') as HTMLDivElement
		const carouselWidth: number = 748

		if (direction == 'left') {
			if (this.carouselPageNowRefused > 1) {
				this.carouselPageNowRefused--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNowRefused < this.carouselPagesRefuse) {
				this.carouselPageNowRefused++
			}
		}

		if (this.carouselPageNowRefused > 1) {
			this.refusedArrowLeftEnable = true
		} else {
			this.refusedArrowLeftEnable = false
		}

		if (this.carouselPageNowRefused == this.carouselPagesRefuse) {
			this.refusedArrowRightEnable = false
		} else {
			this.refusedArrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNowRefused - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public setGaleryOperationServiceRefused() {
		this.operationService.operationRefused.media.forEach((media, index) => {
			const galeryInventoryObj: ImageGaleryOperationService = {
				photo: media,
				evaluation: `Imagem ${String(index + 1).padStart(2, '0')}`
			}

			this.galeryOperationServiceRefused.push(galeryInventoryObj)
		})
		
		this.carouselPagesRefuse = Math.ceil(this.galeryOperationServiceRefused.length / 3)
	}

	public setGaleryOperationService() {
		if (this.operationService.treeMedia) {
			const treeMedia: ImageGaleryOperationService = {
				photo: this.operationService.treeMedia,
				evaluation: this.operationService.source === 'Plantio' ? 'Foto do local' : 'Foto da árvore'
			}

			this.galeryOperationService.push(treeMedia)
		}

		this.operationService.inventorAnswers.forEach(answer => {
			if (answer.photo) {
				const galeryInventoryObj: ImageGaleryOperationService = {
					photo: answer.photo,
					evaluation: answer.evaluation
				}

				this.galeryOperationService.push(galeryInventoryObj)
			}
		})
		
		this.carouselPages = Math.ceil(this.galeryOperationService.length / 3)
	}

	public async openSelectCompanyProvider() {
		await this.getCompaniesServiceProvider()
		this.showSelectCompanyProvider = true
	}

	public closeSelectCompanyProvider() {
		this.showSelectCompanyProvider = false
	}

	public async getCompaniesServiceProvider(): Promise<void> {
		try {
			const handlerOperationIds: Array<string> =
				this.operationService.handlerOperations.map(handlerOperation =>
					handlerOperation.idMongo
				)

			this.companiesServiceProvider =
				await this.companyServiceProviderService.getCompaniesServiceProvider({
					companyId: this.companyId,
					skip: 0,
					limit: 100,
					order: 'CNPJ',
					typeOrder: 'desc',
					handlerOperationIds
				}).toPromise()
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public async selectCompanyProvider(companyProvider: CompanyServiceProvider) {
		try {
			this.notificationService.initLoading()

			const response =
				await this.operationServiceService.setCompanyProviderToOperationService(
					this.operationService.idMongo,
					companyProvider.idMongo
				).toPromise()

			this.notificationService.notify(response, 200)
			this.operationService.companyProvider = companyProvider.socialName
			this.getOperationsServices.emit()
		} catch (error) {
			this.notificationService.notify('Erro ao atribuir empresa!', 500)
		}

		this.closeSelectCompanyProvider()
	}
}
